import { useEffect, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, ConvertToBlobPDF, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { FormButton, InputBox, AutoCompleteBoxNew } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import Modal from 'react-bootstrap/Modal';
import { CommonApiData } from '../CommonComponents/EnvConfig';

const DownloadAdmitCard = (bodyData) => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    let { authToken, loginToken, UserCode, CompanyCode, ...rest } = bodyData;
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const loginUserCode = UserCode ? UserCode : CommonApiData().UserCode
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const userName = CommonApiData().UserName

    const loginUserType = CommonApiData().loginUserType

    const [formData, setFormData] = useState({
        client: loginUserType === "CLIENT"
            ? `${loginUserCode} : ${userName}`
            : "",
        eventCode: "",
        rollNo: "",
        mobileNo: "",
        emailId: ""
    });

    const [singleData, setSingleData] = useState([])
    const [showProfileModal, setShowProfileModal] = useState(false);

    const handleDownloadAdmitCard = async (mobileNo, rollNo, emailId) => {
        try {
            const req = {
                mobileNo,
                rollNo,
                emailId,
                ...formData
            };

            dispatch(setSubLoading(true));

            const data = await ApiCall(`/api/Operation/DownloadAdmitCard`, req);
            if (data?.status === "SUCCESS") {

                const base64String = data?.printUrl
                const contentType = 'application/octet-stream';
                const dataURI = `data:${contentType};base64,${base64String}`;
                const link = document.createElement("a");
                link.href = dataURI;
                link.download = `${data.fileName ? data.fileName : "Document"}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            dispatch(setSubLoading(false)); // always OFF
        }
    };

    const handleClear = async () => {
        setFormData({
            client: loginUserType === "CLIENT"
                ? `${loginUserCode} : ${userName}`
                : "",
            eventCode: "",
            rollNo: "",
            mobileNo: "",
            emailId: ""
        });
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null });
    }

    const handleSearch = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const req = {
            "PageSize": "20",
            Type: 'S',
            PageIndex: `${PageIndex} `,
            ...formData
        }
        await dispatch(setSubLoading(true))

        let data = await ApiCall(`/api/Operation/GetCandidateData`, req)

        if (data.Status === "SUCCESS") {
            setTableData(data)
            if (formData.mobileNo || formData.rollNo || formData.emailId) setShowProfileModal(true)
        }
        if (data.Status === "ERROR") {
            setTableData([])
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs, "");

        }
        await dispatch(setSubLoading(false))
    };


    const handleChange1 = (event, value) => {
        handleSearch(value);
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    useEffect(() => {
       // handleSearch()
        document.title = 'Download File'
        if (loginUserType.toUpperCase() === "CLIENT") {
            inputrefs.current['txtEvent'].focus()
        }
        else {
            inputrefs.current['txtClient'].focus()
        }
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Download File'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col'>

                            <AutoCompleteBoxNew
                                id="txtClient"
                                divclassname='col-md-6 col-sm-12 mb-1'
                                label='Client'
                                required={true}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEvent'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                maxLength='10'
                                placeholder='Client'
                                disabled={loginUserType === "CLIENT"}
                                name='Client'
                                value={loginUserType === "CLIENT" ? (formData.client || "") : ""}
                                onChange={(e) => setFormData({ ...formData, client: e.target.value })}
                                autocompleteType='GetClientData'
                            />
                            <AutoCompleteBoxNew
                                id="txtEvent"
                                divclassname='col-md-6 col-sm-12 mb-1'
                                label='Event'
                                required={true}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtRollNo'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                maxLength='10'
                                placeholder='Event'
                                name='Event'
                                value={formData.event || ''}
                                autocompleteType='GetEventData'
                                contextKey={formData.client}
                                onChange={async (event, newInputValue) => {
                                    newInputValue = newInputValue || ''
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, eventCode: newInputValue })
                                    }
                                }}
                            />
                            <InputBox
                                id="txtRollNo"
                                divclassname='col-md-6 col-sm-12 mb-1'
                                label='Roll No'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtmobileNo'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                maxLength='50'
                                placeholder='Roll No'
                                name='RollNo'
                                value={formData.rollNo}
                                onChange={(e) => setFormData({ ...formData, rollNo: (e.target.value).trim() })}
                            />

                            <InputBox
                                id="txtmobileNo"
                                divclassname='col-md-6 col-sm-12 mb-1'
                                label='Mobile No'
                                placeholder="Mobile No"
                                maxLength='15'
                                value={formData.mobileNo}
                                onChange={(e) => setFormData({ ...formData, mobileNo: (e.target.value).trim() })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEmailId'].focus()
                                    }
                                }}
                            />

                            <InputBox
                                divclassname='col-md-6 col-sm-12 mb-1'
                                id="txtEmailId"
                                placeholder="Email ID"
                                autoComplete="off"
                                maxLength='100'
                                type="email"
                                label='Email ID'
                                value={formData.emailId}
                                onChange={(e) => setFormData({ ...formData, emailId: (e.target.value).trim() })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                            />


                        </div>
                        <div className='card-body mt-2'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSearch={handleSearch}
                                search={true}
                                save={false}
                                Export={false}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Table

                loading={isLoading}
                PageName={'EventMaster'}
                Filter={false}
                matchingkey={'MobileNo'}
                ClickOnLink={() => setShowProfileModal(true)}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

            <Modal
                show={showProfileModal}
                onHide={() => setShowProfileModal(false)}
                backdrop="static"
                dialogClassName="right-side-modal"
                //contentClassName="right-side-content"
                style={{ width: "450px", height: "100vh" }}
                centered={false}
            >
                {/* HEADER (Blue Style Like Image) */}
                <Modal.Header
                    closeButton
                    style={{
                        backgroundColor: "#004196",
                        color: "#fff",
                        borderBottom: "none"
                    }}
                >
                    <Modal.Title
                        style={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#fff"
                        }}
                    >
                        Candidate Profile: {tableData?.Data?.[0]?.Client}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ background: "#f4f6f9" }}>

                    {/* PROFILE CARD */}
                    <div
                        style={{
                            background: "#fff",
                            padding: "15px",
                            borderRadius: "8px",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                            marginBottom: "15px"
                        }}
                    >
                        <div className="mb-2">
                            <strong>ROll No :</strong>{" "}
                            {tableData?.Data?.[0]?.RollNo || "-"}
                        </div>

                        <div className="mb-2">
                            <strong>Mobile No :</strong>{" "}
                            {tableData?.Data?.[0]?.MobileNo || "-"}
                        </div>

                        <div>
                            <strong>Email ID :</strong>{" "}
                            {tableData?.Data?.[0]?.EmailID || "-"}
                        </div>
                    </div>

                    {/* SECTION TITLE */}
                    <h6
                        style={{
                            fontWeight: 600,
                            marginBottom: "10px",
                            color: "#333"
                        }}
                    >
                        Download Data
                    </h6>

                    {/* POST 1 */}
                    <div
                        style={{
                            background: "#fff",
                            padding: "15px",
                            borderRadius: "8px",
                            marginBottom: "12px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
                        }}
                    >
                        <p style={{ marginBottom: "10px" }}>
                            <strong>Event :</strong>{" "}
                            {tableData?.Data?.[0]?.Event}
                        </p>

                        <button
                            className="btn btn-primary btn-sm"
                            style={{
                                width: "100%",
                                borderRadius: "6px",
                                fontWeight: 500
                            }}
                            onClick={() =>
                                handleDownloadAdmitCard(
                                    tableData?.Data?.[0].MobileNo,
                                    tableData?.Data?.[0]?.RollNo,
                                    tableData?.Data?.[0]?.EmailID
                                )
                            }
                        >
                            Download Admit Card
                        </button>
                    </div>

                    {/* If multiple posts later you can duplicate above block */}

                </Modal.Body>

                {/* FOOTER */}
                <Modal.Footer
                    style={{
                        justifyContent: "center",
                        background: "#fff",
                        borderTop: "1px solid #eee"
                    }}
                >
                    <button
                        className="btn btn-light"
                        style={{
                            border: "1px solid #ccc",
                            padding: "6px 20px",
                            borderRadius: "5px"
                        }}
                        onClick={() => setShowProfileModal(false)}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default DownloadAdmitCard;